// src/pages/admin/Dashboard2.js
import React from 'react';

const Dashboard2 = () => {
  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h2>Dashboard v3</h2>
            <p>This is Dashboard version 3 for Admin.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard2;
